var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle3, _circle4, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 1000 1000",
    viewBox: "0 0 1000 1000",
    id: "cat-sitting-in-the-house",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f5f8",
    d: "M0 0h1000v1000H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M243.86 634.66v30.931h-61.862M305.722 665.591H243.86V634.66M212.929 665.591h61.862v30.931h-61.862z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M261.437 727.453H243.86v-30.931h61.862M181.998 696.522h61.862v30.931h-50.163M160.911 665.591h52.018v30.931h-30.931"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M319.432 696.522h-44.641v-30.931h21.443M817.643 441.418v30.931h61.862M755.781 472.349h61.862v-30.931"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M786.712 472.349h61.862v30.931h-61.862z",
    transform: "rotate(-180 817.643 487.814)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M800.066 534.211h17.577V503.28h-61.862M879.505 503.28h-61.862v30.931h50.162M900.592 472.349h-52.018v30.931h30.931M742.07 503.28h44.642v-30.931h-21.444"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 587.034,
    cy: 251.851,
    r: 56.006,
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M587.034 201.561v5.471M587.034 296.67v5.47M637.323 251.851h-5.47M542.215 251.851h-5.471"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 587.034,
    cy: 251.851,
    r: 4.523,
    fill: "#e5e5e5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "m587.034 251.851 24.151-29.889"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "m571.795 236.906 15.239 14.945"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M135.838 252.95H259.14v125.311H135.838z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M154.255 271.175h86.469v88.86h-86.469z",
    transform: "rotate(90 197.49 315.605)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M289.227 212.972h108.626v77.757H289.227z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M320.612 213.488h45.856v76.725h-45.856z",
    transform: "rotate(90 343.54 251.85)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M292.697 352.597h72.635v47.673h-72.635z",
    transform: "rotate(90 329.014 376.433)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e5e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M289.227 324.166h79.575v104.536h-79.575z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a83727",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "m833.833 784.156 7.917.013M802.333 784.221h18.5M473 784.221h315.333M200 784.221h252M156.5 784.221h22M126.5 784.221h12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#6dcca3",
    d: "M330.899 674.41c-18.226-11.597-50.343-32.032-64.218-74.435-9.675-29.567-9.915-66.84.523-70.338 12.062-4.041 33.152 38.776 40.916 35.106 6.091-2.879-6.607-29.368-8.333-74.333-1.176-30.636 3.236-56.933 17-80.333 6.32-10.745 10.931-18.583 16-18 20.905 2.403 14.971 144.005 37.333 146.667 10.509 1.251 18.928-29.177 30.667-26.667 9.98 2.135 16.691 26.844 18.47 42.808.088.789.152 1.418.197 1.858 5.241 51.897-25.052 89.304-35.333 102-15.256 18.839-25.639 22.554-33.554 22.667-8.346.119-14.722-3.854-19.668-7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#465172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M325.5 477c3.514 37 24.486 93.253 27.612 141a397.125 397.125 0 0 1-3 81"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2359b2",
    d: "M422.01 784.221H267.002a87.357 87.357 0 0 1 1.543-88.518l22.799-37.286H397.67l22.149 34.519a87.356 87.356 0 0 1 5.17 85.106l-2.979 6.179z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#465172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M375.022 561.879s-.404 17.005-23.783 39.121M301.112 601s15.691 32 52.846 32"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1e2a54",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M382.324 684.799s23.577 15.359 23.577 52.28",
    opacity: 0.67
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6d6d6",
    d: "M523.593 794.04c0 29.249 49.86 52.96 111.365 52.96 48.154 0 89.17-14.534 104.708-34.882l-116.47 8.401-99.603-26.479z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78a21",
    d: "M723.662 791.053c-2.929-.613-5.962-.331-8.746.767-17.59 6.941-48.385 11.543-83.44 11.543-54.676 0-99-11.193-99-25 0-12.216 34.697-22.383 80.559-24.565l3.154-16.718c-62.905 3.907-110.714 23.366-110.714 46.784 0 26.234 59.994 47.5 134 47.5 32.41 0 62.131-4.079 85.302-10.868 15.181-4.449 14.368-26.202-1.115-29.443z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b463d",
    d: "m671.141 801.275 47.994-10.468s12.576 1.345 14.899 8.008c3.983 11.422-4.18 18.372-4.18 18.372s-3.187-26.38-58.713-15.912z",
    opacity: 0.26
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a83727",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M723.662 791.053c-2.929-.613-5.962-.331-8.746.767-17.59 6.941-48.385 11.543-83.44 11.543-54.676 0-99-11.193-99-25 0-12.216 34.697-22.383 80.559-24.565l3.154-16.718c-62.905 3.907-110.714 23.366-110.714 46.784 0 26.234 59.994 47.5 134 47.5 32.41 0 62.131-4.079 85.302-10.868 15.181-4.449 14.368-26.202-1.115-29.443h0z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78a21",
    d: "M714.301 439.872c-16.036-5.119-33.69-7.956-52.231-7.956-18.394 0-35.916 2.789-51.851 7.832-9.651-22.737-22.863-41.212-36.842-52.724-2.196-1.808-5.491-1.153-6.868 1.335-27.714 50.066-40.134 107.362-34.862 169.87 4.825 69.769 31.701 146.546 57.209 225.771h146.843c25.594-79.238 52.183-155.102 57.164-223.986 5.462-62.905-7.089-120.413-35.615-171.013-1.401-2.485-4.715-3.111-6.894-1.27-13.692 11.575-26.591 29.805-36.053 52.141z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b463d",
    d: "M674.446 533.937c0 3.717-5.541 6.729-12.375 6.729-6.835 0-12.376-3.013-12.376-6.729l12.545-2.812 12.206 2.812zM713.321 782.594s.01-7.862 1.5-14.5c13.167-58.667 4.522-76.75 4.522-76.75l-27.833 91.471 21.811-.221zM608.819 782.594s-.01-7.862-1.5-14.5c-13.167-58.667-4.522-76.75-4.522-76.75l27.833 91.471-21.811-.221z",
    opacity: 0.26
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a83727",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M714.301 439.872c-16.036-5.119-33.69-7.956-52.231-7.956-18.394 0-35.916 2.789-51.851 7.832-9.651-22.737-22.863-41.212-36.842-52.724-2.196-1.808-5.491-1.153-6.868 1.335-27.714 50.066-40.134 107.362-34.862 169.87 4.825 69.769 31.701 146.546 57.209 225.771h146.843c25.594-79.238 52.183-155.102 57.164-223.986 5.462-62.905-7.089-120.413-35.615-171.013-1.401-2.485-4.715-3.111-6.894-1.27-13.692 11.575-26.591 29.805-36.053 52.141z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.603,
    cy: 479.815,
    r: 8,
    fill: "#a83727"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.603,
    cy: 479.815,
    r: 8,
    fill: "#a83727"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#a83727",
    d: "M668.771 506.725a67.276 67.276 0 0 0-13.235 0c-2.056.204-2.817 2.31-1.2 3.367 1.379.901 2.764 1.846 4.151 2.833 2.014 1.434 5.318 1.434 7.333 0a126.559 126.559 0 0 1 4.151-2.833c1.617-1.057.856-3.164-1.2-3.367z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78a21",
    d: "M719.135 694.221c-1.698 29.521-15.369 60.479-24.833 90H662.07l.223-83.087"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78a21",
    d: "M605.006 694.221c1.698 29.521 18.369 60.479 27.833 90h29.232l-.223-83.087"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a83727",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M680.487 532.998a13.064 13.064 0 0 1-6.243 1.56c-6.675 0-12.086-4.865-12.086-10.866M643.74 532.998c1.822.99 3.959 1.56 6.243 1.56 6.675 0 12.086-4.865 12.086-10.866M719.135 694.221c-1.698 29.521-18.369 60.479-27.833 90H662.07l.223-83.087"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a83727",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M605.006 694.221c1.698 29.521 15.369 60.479 24.833 90h32.232l-.223-83.087"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b463d",
    d: "M729.07 451.389c7.429-22.698 18.159-28.476 18.159-28.476s7.841 2.889 7.841 33.841M595.07 451.389c-7.429-22.698-18.159-28.476-18.159-28.476s-7.841 2.889-7.841 33.841",
    opacity: 0.26
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a83727",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "m644.267 772.25 2.5 11.25M679.873 772.25l-2.5 11.25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a83727",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M706.967 528.65c12.085 3.169 24.556 3.836 36.641 2M703.57 536.255c11.015 7.038 22.382 11.795 33.397 14.271M706.967 517.859c9.895-.662 20.105-3.374 30-8.134M617.173 528.65c-12.085 3.169-24.556 3.836-36.641 2M620.57 536.255c-11.015 7.038-22.382 11.795-33.397 14.271M617.173 517.859c-9.895-.662-20.105-3.374-30-8.134"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChat);
export default __webpack_public_path__ + "static/media/empty-chat.c4c84366557673508b893ed468f0a609.svg";
export { ForwardRef as ReactComponent };